import snakeCase from 'lodash/snakeCase';
import { convertObject } from 'utils/convertObject';

export const convertCamelToSnakeCase = (param: any) =>
  convertObject({
    mutator: snakeCase,
    param,
  });
